import request from "../utils/request.js";

/**
 * 运营后台资产上传 - 获取预签名URL
 * @param {Object} data
 * @param {string} data.fileName     文件名（带扩展名）
 * @param {string} data.contentType  内容类型，如 application/zip
 * @param {string} data.businessType 业务类型，如 music/wallpaper
 * @param {Object} [config={}] axios 附加配置，如 cancelToken
 */
export function getAssetUploadCredential(data, config = {}) {
  return request({
    url: "/upload/credentials/asset",
    method: "post",
    data,
    ...config
  });
}
